var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('video',{ref:"video",attrs:{"loop":"","muted":"","playsinline":"","preload":"metadata"},domProps:{"muted":true}},[_c('source',{attrs:{"src":this.av1,"type":"video/mp4; codecs=av01.0.05M.08"}}),_vm._v(" "),_c('source',{attrs:{"src":this.mp4,"type":"video/mp4"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }